import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

export const Quote: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <blockquote
      ref={ref as unknown as React.RefObject<HTMLQuoteElement>}
      className={`border-l-4 border-zinc-300 dark:border-zinc-700 pl-4 py-2 mb-6 italic text-xl text-zinc-700 dark:text-zinc-300 transform transition-all duration-700 ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-8 opacity-0'
      }`}
    >
      {children}
    </blockquote>
  );
};
